export const WORKFLOW_ID = 'EmergencyFundWorkflow';
export const ANALYTICS_ID = 'emergency_fund_workflow';
export const BACKEND_EMERGENCY_FUND_GOALS_KEY = 'EmergencyFundGoals';
export const BACKEND_EMERGENCY_FUND_GOAL_API = 'EmergencyFundGoal';
